export default __webpack_public_path__ + "static/media/elegant.157e074e.jpg";